import React from 'react';

import type { MenuSection, SectionId } from '../types';

interface MobileNavProps {
  menuSections: MenuSection[];
  activeSection: SectionId;
  onSelectSection: (sectionId: SectionId) => void;
}

function MobileNav({ menuSections, activeSection, onSelectSection }: MobileNavProps) {
  return (
    <div className="mb-4 xl:hidden">
      <div className="rounded-xl border border-slate-200 bg-white shadow-md">
        <div
          className="rounded-t-xl px-4 py-2 text-center font-semibold text-white"
          style={{ background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)' }}
        >
          <span role="img" aria-label="menu">📂</span> Navigation
        </div>
        <div className="p-3">
          <label htmlFor="rdv-mobile-select" className="text-xs text-slate-600">Aller à :</label>
          <select
            id="rdv-mobile-select"
            value={activeSection}
            onChange={(e) => onSelectSection(e.target.value as SectionId)}
            className="mt-1 w-full rounded-lg border-2 px-3 py-2"
          >
            {menuSections.map((section) => (
              <optgroup key={section.id} label={section.title.replaceAll(/<[^>]+>/g, '')}>
                {section.items.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.title}
                  </option>
                ))}
              </optgroup>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}

export default MobileNav;


